import {command,outputAsset,readOnly} from './api'
import type {ScreenReviewDetail,ScreenReviewList,ScreenAsset} from '../../supabase/functions/agent-queue/screenReviewModel'
export interface ScreenReviewClient{
 writable:boolean
 list(offset?:number):Promise<ScreenReviewList>
 task(id:string):Promise<ScreenReviewDetail>
 write(action:string,payload:Record<string,unknown>):Promise<{ok?:boolean;request_id?:string;revision?:number;queued?:boolean}>
 asset(asset:ScreenAsset):Promise<string>
}
export const screenReviewClient:ScreenReviewClient={
 writable:!readOnly,
 list:(offset=0)=>command('screen_review_list',{offset}),
 task:id=>command('screen_review_task',{id}),
 write:(action,payload)=>command(action,payload,true),
 asset:asset=>outputAsset(asset.id,asset.media),
}
